import {Game} from "@game/game";
import {Vector2} from "@utility/vector2";
import {Bounds2} from "@utility/bounds2";
import {TopBar} from "@components/interface/TopBar";
import {BottomBar} from "@components/interface/BottomBar";
import {useEffect, useState} from "react";
import {Hand} from "@game/player/hand";
import {Compass} from "@components/map/Compass";
import {UserPlayer} from "@game/player/userPlayer";

interface IOverlay {
    dragPosition: Vector2
    game: Game
    onActive: () => void
    onBarBounds: (bounds: Bounds2) => void
    onHome: () => void
    onShovel: () => void
    setInsert: (insert: number) => void
    shovelling: boolean
    userPlayer: UserPlayer
    viewportCenter: Vector2
    viewportTileBounds: Bounds2
}
export function Overlay({dragPosition, game, onActive, onBarBounds, onHome, onShovel, setInsert, shovelling, userPlayer, viewportCenter, viewportTileBounds} : IOverlay) {
    const [hand, setHand] = useState<Hand>();

    useEffect(() => {
        const handleUpdate = () => {
            setHand(game.userPlayer?.hand);
        };

        if (game.userPlayer) {
            game.userPlayer.events.delegates.add(handleUpdate);
            return () => game.userPlayer?.events.delegates.remove(handleUpdate);
        }
    }, [game.userPlayer]);
    if (hand === undefined) return null;
    return (
        <div>
            <BottomBar dragPosition={dragPosition} game={game} hand={hand}
                       onActive={onActive} onBarBounds={onBarBounds} onShovel={onShovel} setInsert={setInsert} shovelling={shovelling}/>
            <Compass game={game} onHome={onHome} userPlayer={userPlayer} viewportCenter={viewportCenter}
                     viewportTileBounds={viewportTileBounds}/>
            <TopBar game={game}/>
        </div>
    );
}
